import IngredientShow from './IngredientShow'
export {IngredientShow}
export default IngredientShow
